import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import LineTitle from '../atoms/titles/LineTitle';
import LineTitleGray from '../atoms/titles/LineTitleGray';
import Textlink from '../atoms/link/Textlink';
import SubscriptionNoteTable from './SubscriptionNoteTable';
import { ENABLE_GIFT_CARD_FEATURE }  from '../../constants';

const NoteEntryConfirmation = ({ noteRef }) => {
  const tripConditionUrl = 'http://rsv.nta.co.jp/F_Booking/static/ryokojoken_shusai.htm';

  const todayDisplay =  moment().format('YYYY年M月D日(ddd)');

  return (
    <div ref={noteRef} id="noteEntryConfirmation" className="notesWrapper">
      <LineTitleGray size="lg">申し込み注意事項</LineTitleGray>
      <div className="noteItems">
        <div className="noteItem">
          <LineTitle text="取消規定" />
          <div className="noteItemBody">
            <p className="noteText noteTextStrong">
                    取消料発生日：
              <span className="noteTextRed">{todayDisplay}</span>から取り消し料がかかります。
            </p>
            <div className="noteTable">
              <SubscriptionNoteTable />
            </div>
            <div className="noteTable noteTableSP">
              <SubscriptionNoteTable />
            </div>
            <div className="noteText">
              <div className="mb-5">予約完了後、お客様のご都合で予約取り消しを行った場合、即時で取消料一覧に定めた取消料をいただきます。</div>
              詳しい条件などは<Textlink to={tripConditionUrl} outgoing>こちら</Textlink>をご確認ください。
            </div>
          </div>
        </div>
        <div className="noteItem">
          <LineTitle text="予約に関する重要事項" />
          <div className="noteItemBody">
            <div className="reserveNote">
              <div className="checkIcon">
                <img src="/dpp/img/icons/checkRed.svg" alt="" />
              </div>
              <div className="reserveNoteTexts">
                <p className="noteTextRed reserveNoteTextBold">ご予約時には、参加されるお客様全員のお名前、生年月日が必要です</p>
                <p>お客様情報入力画面にて、お名前と生年月日の入力が必要です。ご確認の上、次の画面へお進みください。</p>
              </div>
            </div>
            <div className="reserveNote">
              <div className="checkIcon">
                <img src="/dpp/img/icons/checkRed.svg" alt="" />
              </div>
              <div className="reserveNoteTexts">
                <p className="noteTextRed reserveNoteTextBold">クレジットカード決済</p>
                <p>利用いただけるクレジットカードはお申込みされる方ご本人様名義のものに限ります。マイページ会員予約・会員登録せずに予約が選べます。</p>
              </div>
            </div>
            <div className="reserveNote">
              <div className="checkIcon">
                <img src="/dpp/img/icons/checkRed.svg" alt="" />
              </div>
              <div className="reserveNoteTexts">
                <p className="noteTextRed reserveNoteTextBold">ご予約後の変更はできません</p>
                <p>現予約を取消後、新規にご予約のお取り直しをお願いいたします。取消には所定の取消料が必要です。お申込み期限を切った場合は再予約もできません。また、旅行者氏名・年齢の訂正もできません。新たにご予約のお取り直しをお願いいたします。</p>
              </div>
            </div>
            <div className="reserveNote">
              <div className="checkIcon">
                <img src="/dpp/img/icons/checkBlack.svg" alt="" />
              </div>
              <div className="reserveNoteTexts">
                <p className="reserveNoteTextBold">インターネット限定</p>
                <p>ネット申込限定商品のため、店舗、予約センターでは予約、お問い合わせいただけません。</p>
              </div>
            </div>
            <div className="reserveNote">
              <div className="checkIcon">
                <img src="/dpp/img/icons/checkBlack.svg" alt="" />
              </div>
              <div className="reserveNoteTexts">
                <p className="reserveNoteTextBold">チケット送付はありません</p>
                <p>ご出発前に、必ずマイページからeチケットお客様控を印刷、もしくはスマートフォンに二次元バーコードが表示されることをご確認ください。</p>
              </div>
            </div>
            <div className="reserveNote">
              <div className="checkIcon">
                <img src="/dpp/img/icons/checkBlack.svg" alt="" />
              </div>
              <div className="reserveNoteTexts">
                <p className="reserveNoteTextBold">代理の方のお申込みはできません</p>
                <p>旅行者と予約者が異なるお申込みはできません。</p>
              </div>
            </div>
          </div>
        </div>
        <div className="noteItem">
          <LineTitle text="注意事項" />
          <div className="noteItemBody">
            {/* <div className="caution">
              <div className="cautionTitle">推奨ブラウザ (利用環境)</div>
              <div
                className="cautionText"
              >弊社ホームページを快適にご利用いただくためには Windows Internet Explorer 8.0 を推奨しています。お客様のパソコンの環境によっては一部機能が動作しない場合があります。<br />また、スマートフォンについては、iOS（Ver3.2）・Android OS(Ver1.6/2.1/2.2)にて動作検証を行なっております。 ※恐れ入りますがマッキントッシュ（Mac）機には対応しておりません。</div>
            </div> */}
            <div className="caution">
              <div className="cautionTitle">旅行期間</div>
              <div
                className="cautionText"
              >2日間～最大8日間。この期間であれば復路航空便利用日の延長が可能です。申込後の利用日の変更はできませんので、ご注意ください。</div>
            </div>
            <div className="caution">
              <div className="cautionTitle">お申込み人数</div>
              <div className="cautionText">大人2名様以上（一部プランは大人1名様より）</div>
            </div>
            <div className="caution">
              <div className="cautionTitle">旅行代金について</div>
              <div
                className="cautionText"
              >・旅行代金は、往復航空機＋宿泊代金となります（サービス料・消費税等諸税含む）。搭乗便、搭乗時間、発着地によって旅行代金が異なる場合があります。
                <br /><span className="noteTextRed">・時価販売商品のため旅行代金は変動する場合がございます。最終確認画面にて再度旅行代金をご確認ください。</span></div>
            </div>
            <div className="caution">
              <div className="cautionTitle">お支払い方法</div>
              <div className="cautionText">
                ・クレジットカード決済<br/>
                <div style={{ paddingLeft: 16, paddingRight: 16 }}>
                  ※代表者ご本人様以外のクレジットカードはご利用いただけません。
                </div>
                {ENABLE_GIFT_CARD_FEATURE && (
                  <React.Fragment>
                    <br/>
                    ・日本旅行ギフトカード・ドリーム旅行カード
                    <div style={{ paddingLeft: 16, paddingRight: 16 }}>
                      ご利用可能なカード、ご利用条件につきましては詳細ページをご覧ください。<br />
                      <Textlink to="https://www.nta.co.jp/nrs/gift.htm" outgoing>{'> 日本旅行ギフトカード'}</Textlink>　　
                      <Textlink to="https://www.nta.co.jp/nrs/dreamplan.htm" outgoing>{'> ドリーム旅行カード'}</Textlink><br />
                      ※ご利用の際併用できる決済方法はクレジットカードのみとなります。
                    </div>
                  </React.Fragment>
                )}
              </div>
            </div>
            <div className="caution">
              <div className="noteTextRed cautionTitle">お子様（こども）について</div>
              <div
                className="noteTextRed cautionText"
              >6歳以上のお子様は航空座席のみ（添い寝）のご予約はお取扱はできません。<br />
              こども(0～5歳)のお子様は「航空座席・寝具・食事なし」の予約が可能となります。<br />
              ※ただし、2026/05/19以降のANA便利用はこども(2歳)のお子様は「航空座席あり、寝具・食事なし」となります。
              </div>
            </div>
            <div className="caution">
              <div className="cautionTitle">宿泊施設の空室状況について</div>
              <div
                className="cautionText"
              >施設の空室状況は、現時点での空室ではありません。ページ内に記載の最終更新日時時点での情報となります。 お申込み完了時に満室となりお取りできない場合もございますので、ご了承ください。</div>
            </div>
            <div className="caution">
              <div className="cautionTitle">利用便の決定について</div>
              <div
                className="cautionText"
              >予約完了と同時に便が確定いたします。</div>
            </div>
            <div className="caution">
              <div className="cautionTitle">集合時刻・集合場所・出発時刻</div>
              <div
                className="cautionText"
              >出発前にご自身でマイページからeチケットお客様控を印刷してください。 またはお手持ちのモバイルにeチケットお客様控の画像を各自保存してください。 お客様ご自身でチェックインをお済ませの上、出発の20分前までに保安検査場を通過してください。詳細は各航空会社のホームページをご確認ください。
                <br/>※ＡＮＡ便をご利用の場合ご予約便出発の24時間前～20分前までにオンラインチェックインをお済ませください。
              </div>
            </div>
            <div className="caution">
              <div className="cautionTitle">事前座席指定</div>
              <div
                className="cautionText"
              >ご予約完了直後より座席番号および窓側・通路側・並びなど座席指定が可能です。マイページの「航空座席指定／解除」ボタンよりお進みください。なお、ご希望の座席がお取りできない場合もございます。また機材変更などのやむをえない場合により、予告なしに座席が変更・取消になる場合があります。予めご了承ください。<br />※事前座席指定いただける席には限りがございます。</div>
            </div>
            <div className="caution">
              <div className="cautionTitle">ファーストクラス、プレミアムクラスのご利用について</div>
              <div
                className="cautionText"
              >当日航空会社カウンターにお尋ねください。（事前予約はできません）</div>
            </div>
            <div className="caution">
              <div className="cautionTitle">マイルについて</div>
              <div
                className="cautionText"
              >会員番号の登録は、マイページの「マイレージ番号」から操作を行うことができます。</div>
            </div>
            <div className="caution">
              <div className="cautionTitle">注意点</div>
              <div
                className="cautionText"
              >・お客様都合による旅行中止の場合、未使用部分についての払戻は一切できません（欠航等による場合はこの限りではありません）。<br />・掲載しているフライトスケジュールは、設定中止や大幅な変更が発生する場合があります。<br />事前にフライトスケジュールを各航空会社ホームページにてご確認ください。<br />・フライト時間が変更になった場合には便名が優先されます。<br />（照会画面に表示される時間帯は予定時刻であり、スケジュール変更等で表示時間帯以外になる場合がございます。出発時刻については航空会社のホームページ等で必ず確認をお願い致します。）<br />・満席等によりお客様のご希望にお応えできない場合がありますので、予めご了承ください。<br />・旅行商品上、ご利用いただける席数に制限がある場合がございます。一般席に空席があっても当該商品では満席になる場合があります。<br />・お申込み最終期限は、ご出発の前日23:59までとなります。<br />・ご予約後の利用便の変更・お名前・年齢の変更は一切できません（変更する場合は新たに旅行契約を締結していただくことになります。この場合、所定の取消料が必要です）。<br />・車いすなどお手伝いの必要なお客様は、取扱店舗までご連絡ください。</div>
            </div>
            <div className="caution">
              <div className="cautionTitle">予約の変更について</div>
              <div className="cautionText">
                予約内容の変更はできません。現予約を取消後、新規に予約をお取り直しいただきます。 ※この場合所定の取消料が必要です。詳しくは
                <Textlink to={tripConditionUrl} outgoing>こちら</Textlink>
                （→旅行条件書） をご覧ください。 ※ご希望の航空便や宿泊施設が満席・満室などで、予約できない場合があります。また、旅行者氏名・年齢の訂正もできません。新たにご予約のお取り直しをお願いいたします。
              </div>
            </div>
            <div className="caution">
              <div className="cautionTitle">予約の取消について</div>
              <div className="cautionText">
                ご宿泊日の前日（23：59）まで、オンラインでの予約取消が可能です。 ※予約の取消の場合、原則として予約確定後は所定の取消料が必要です。詳しくは
                <Textlink to={tripConditionUrl} outgoing>こちら</Textlink>
                （→旅行条件書）をご覧ください。<br />
                ※マイページの取消ができなかった場合（取扱店舗にも連絡が通じない場合）については、一旦航空会社・宿泊施設に直接取消の旨をご連絡いただき（その際担当者名をお控えください。）、翌営業日に取扱店舗までご連絡ください。
              </div>
            </div>
            <div className="caution">
              <div className="cautionTitle">ご旅行について</div>
              <div
                className="cautionText"
              >添乗員・現地係員の同行しない個人旅行です。このご旅行では約款に定める旅程管理は行いません。<br />弊社からご旅行に必要はクーポン券類のお渡しや送付はありません。<br />ご搭乗時に必要なeチケットお客様控はご自身で印刷、または画像を保存してください。ご旅行中の諸手続きはお客様ご自身で行っていただきます。</div>
            </div>
            <div className="caution">
              <div className="cautionTitle">最少催行人員</div>
              <div className="cautionText">大人2名様以上（一部プランは大人1名様より）</div>
            </div>
            <div className="caution">
              <div className="cautionTitle">旅行条件書</div>
              <div
                className="cautionText"
              >詳しい旅行条件を必ずご確認の上、お申し込みください。<Textlink to={tripConditionUrl} outgoing>こちら</Textlink>（→旅行条件書） をご覧ください。</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

NoteEntryConfirmation.propTypes = {
  noteRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ]).isRequired,
};

export default NoteEntryConfirmation;
